export type ISettingsResources = typeof SettingsResources;

export const SettingsResources = {
    firstLastNameInvalidError: "Podaj imię i nazwisko",
    aliasRequiredError: "Podanie nicku jest wymagane",
    firstLastNameInvalidCharsError: "Użyj liter z polskiego alfabetu",
    accountNumberInvalid: "Numer rachunku musi składać się z 26 cyfr",
    bankNameInvalidError: "Numer rachunku jest nieprawidłowy",
    firstLastNameLabel: "Imię i nazwisko",
    saveChanges: "Zapisz zmiany",
    email: "Adres wysyłki",
};
